module.exports = __webpack_public_path__ + "img/email.e868eebc.png";